import { memo, useEffect, useMemo } from 'react';
import { attachNewRelicRouteSync } from '../observability/attachNewRelicRouteSync';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';
import UnAuthorized from '../pages/Unauthorized';
import { privateRouteList, publicRouteList, registerRouteList } from '.';
import PrivateRouter from './PrivateRouter';
import PublicRouter from './PublicRouter';
import RegisterRouter from './RegisterRouter';
import { NewRelicRouteTracker } from '../observability/NewRelicRouteTracker';

function RoutesComponent() {
  const render = () => {
    return (
      <Route element={<NewRelicRouteTracker />}>
        {/* Private Route List */}
        {privateRouteList.map(({ title, path, isBack, allowedRoles, className = '', layout, element: Element }) => (
          <Route
            element={
              <PrivateRouter
                layout={layout}
                allowedRoles={allowedRoles}
                title={title}
                isBack={isBack}
                className={className}
              />
            }>
            <Route path={path} element={<Element />} />
          </Route>
        ))}

        {/* Register Route List */}
        {registerRouteList.map(({ title, path, allowedRoles, layout, element: Element }) => (
          <Route element={<RegisterRouter layout={layout} allowedRoles={allowedRoles} title={title} />}>
            <Route path={path} element={<Element />} />
          </Route>
        ))}

        {/* Public Route List  */}
        {publicRouteList.map(({ title, path, layout, element: Element }) => (
          <Route element={<PublicRouter layout={layout} title={title} />}>
            <Route path={path} element={<Element />} />
          </Route>
        ))}

        <Route path={'/*'} element={<UnAuthorized />} />
      </Route>
    );
  };

  const router = useMemo(() => createBrowserRouter(createRoutesFromElements(render())), []);

  useEffect(() => {
    return attachNewRelicRouteSync(router);
  }, [router]);

  return <RouterProvider router={router} />;
}

export default memo(RoutesComponent);
